export default __webpack_public_path__ + "static/media/05_photo.a70ced82.jpg";